<template lang="pug">
.userNotificationsDropdownItemComponentProsvet
  template(v-if="item.type !== NotificationType.Wrong")
    .message {{item.message}}
    a(
      :href="item.title ?? ''"
      :style="{color: '#2356ce'}"
    ) {{item.title ?? ''}}
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type AbstractNotification from '@notifications/models/AbstractNotification'
import { NotificationType } from '@notifications/config'
import { useRouter } from 'vue-router'
interface Props {
  item: AbstractNotification
}
const props = defineProps<Props>()
const emit = defineEmits<{
  (e: 'action'): void
  (e: 'read'): void
}>()

const dateClasses = computed(() => ({ _unread: !props.item.isRead }))

const router = useRouter()

const onButtonClick = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  router.push(props.item.link)
}
</script>

<style lang="sass" scoped>
.userNotificationsDropdownItemComponentProsvet
  > .date
    @include font('t14')
    position: relative
    color: $colorGray
    text-transform: uppercase

    &._unread
      padding-left: 4*$u

      &:before
        content: ''
        position: absolute
        top: 50%
        transform: translateY(-50%)
        left: 0
        width: 2*$u
        height: 2*$u
        background: $colorSecondary2
        border-radius: 50%

  > .title
    @include font('t14')
    color: $colorPrimary

  > .message
    margin-top: 2*$u

  > .actions
    display: flex
    flex-flow: row wrap
    align-items: center
    margin: -2*$u
    margin-top: 3*$u
    > .button
      margin: 2*$u

  @media (max-width: $screenSizeS)
    > .date
      @include font('t12')
</style>
